import React from "react";
import { useLobby } from "../../redux/lobby";
import { formatTime } from "../../util/util";
import Loader from "../../components/ui/loader";
import { saveAndChooseGame } from "../shared/saveAndChooseGame";
import useTranslation from "next-translate/useTranslation";
import { TimeControl, VARIANT_CHESS } from "@chesshotel/constants";
// import { FaDiceSix } from 'react-icons/fa';
import { useDaily } from "@/redux/daily";
import { useUser } from "@/redux/user";

function Spinner() {
  return (
    <div className="absolute right-0.5 top-0 z-10">
      <Loader color="blue" />
    </div>
  );
}

export default function GameButtonDropdown({
  time = null,
  inc = null,
  variant = VARIANT_CHESS,
  turnLength = null,
  onClick = null,
}) {
  const lobby = useLobby();
  const chosenTime = lobby.time;
  const chosenInc = lobby.inc;
  const chosenVariant = lobby.variant;
  const chosenTurnLength = lobby.turnLength;
  const chosenTimeControl = lobby.timeControl;
  const gamesCreated = lobby.gamesCreated;

  const { invites } = useDaily();
  const { id } = useUser();

  const { t } = useTranslation("common");
  const timeControl = turnLength ? TimeControl.DAILY : TimeControl.LIVE;

  let isSentGame = false;
  gamesCreated.forEach((game) => {
    if (
      time == game.time &&
      inc == game.inc &&
      variant == game.variant &&
      turnLength == null
    ) {
      isSentGame = true;
    }
  });

  invites.forEach((invite) => {
    if (
      id === invite.userId &&
      variant == invite.variantId &&
      turnLength == invite.turnLength
    ) {
      isSentGame = true;
    }
  });
  const isChosenGame =
    chosenTimeControl == TimeControl.LIVE
      ? time === (chosenTime && Number(chosenTime)) &&
        inc === (chosenInc && Number(chosenInc)) &&
        variant === (chosenVariant && Number(chosenVariant))
      : turnLength === (chosenTurnLength && Number(chosenTurnLength)) &&
        variant === (chosenVariant && Number(chosenVariant));

  function renderInfo() {
    if (turnLength) {
      return t("days", { count: turnLength });
    }
    if (!turnLength) {
      return formatTime(time, inc);
    }
  }

  return (
    <button
      className={`relative flex whitespace-nowrap flex-col flex-1 items-center justify-center 
         rounded  w-full shadow-custom text-altblue-500 p-1.5  
         ${
           isChosenGame
             ? "bg-blue-100 border-2 border-altblue-500"
             : "hover:opacity-70 bg-gray-200 border-2 border-gray-200"
         }
         `}
      onClick={(e) => {
        onClick && onClick(e);

        if (
          (time !== null && inc !== null && variant !== null) ||
          (turnLength !== null && variant !== null)
        ) {
          saveAndChooseGame(time, inc, variant, turnLength, timeControl);
        }
      }}
    >
      {isSentGame && <Spinner />}
      {(time || turnLength) && (
        <div className="flex items-center space-x-0.5 text-sm">
          <div className="font-normal">{renderInfo()}</div>
        </div>
      )}
    </button>
  );
}
